var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-chip",
        {
          on: {
            click: function($event) {
              _vm.showEvents = true
            }
          }
        },
        [_vm._v("\n    Histórico de eventos do pedido\n  ")]
      ),
      _vm._v(" "),
      _c("Events", {
        attrs: { events: _vm.events, enabled: _vm.showEvents },
        on: {
          close: function($event) {
            _vm.showEvents = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-430d03e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-430d03e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Orders/ShowOrder/Events/Index.vue
// module id = null
// module chunks = 